/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AppServices_Features_DistributablePermissionListingDto } from '../models/Wealthlane_AppServices_Features_DistributablePermissionListingDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PermissionService {

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getApiIdentityPermission(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/permission',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AppServices_Features_DistributablePermissionListingDto OK
     * @throws ApiError
     */
    public static getApiIdentityFeaturesPermissionsDistributable(): CancelablePromise<Wealthlane_AppServices_Features_DistributablePermissionListingDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/features/permissions/distributable',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
